import { RabbitEnvironments } from '@rabbit/data/types';
import { LoadingSpinner } from '@rabbit/elements/shared-components';
import {
  firebaseAuth,
  firebaseFunctions,
} from '@rabbit/firebase/adapter-react';
import { signInWithCustomToken } from 'firebase/auth';
import { nestApiVerifyMagicToken } from '@rabbit/bizproc/core';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const FIREBASE_MODE = import.meta.env['VITE_FIREBASE_MODE'];

export default function InterLoader() {
  const [urlSearchParams] = useSearchParams();
  const token = urlSearchParams.get('token');
  const email = urlSearchParams.get('email');
  const redirectUrl = urlSearchParams.get('redirect_url');
  const navigate = useNavigate();

  useEffect(() => {
    switch (location.pathname) {
      case '/magic-link':
        if (token) {
          if (email) {
            localStorage.setItem('signInEmail', decodeURIComponent(email));
          }
          (async () => {
            try {
              const res = await nestApiVerifyMagicToken({ token });
              if (res?.data) {
                const { data: idToken } = res;
                localStorage.removeItem('emailForSignIn');
                await signInWithCustomToken(firebaseAuth, idToken);
                const storedRedirect = localStorage.getItem(
                  'emailSignIn_redirectUrl'
                );
                const effectiveRedirect = redirectUrl || storedRedirect || '/';
                if (storedRedirect) {
                  localStorage.removeItem('emailSignIn_redirectUrl');
                }
                localStorage.setItem('redirectUrl', effectiveRedirect);
                navigate('/');
              } else {
                if ((res as any)?.statusCode === 401) {
                  toast.error('Link is invalid or expired');
                  navigate('/auth');
                }
                if ((res as any)?.statusCode === 400) {
                  toast.error(
                    'Account with email does not exist, please sign up'
                  );
                  navigate('/auth');
                }
              }
            } catch (e) {
              console.debug(e);
              toast.error('Link is invalid or expired');
              navigate('/auth');
            }
          })();
        }
    }
  }, [location.pathname, token, email, redirectUrl, navigate]);

  return <LoadingSpinner size="sm" isFullScreen />;
}
